<template>
	<div>
		<CRow>
			<CCol col="12">
				<CCard>
					<CCardHeader> (COLIKADO) - Résumé de la journée par type de réception </CCardHeader>

					<CCardBody>
						<CCol col="4">
							<vc-date-picker
								v-model="searchDate"
								:model-config="modelConfig"
								:masks="masks"
								mode="date">
								<template v-slot="{ inputValue, inputEvents }">
									<div role="group" class="form-group">
										<label for="shipping-date">Choisissez une autre date</label>
										<div class="input-group">
											<input
												id="shipping-date"
												type="string"
												name="searchDate"
												class="form-control"
												:value="inputValue"
												v-on="inputEvents" />
											<div class="input-group-append">
												<span class="input-group-text">
													<CIcon name="cil-calendar" />
												</span>
											</div>
											<small class="form-text text-muted w-100"
												>Exemple: 06/12/2021</small
											>
										</div>
									</div>
								</template>
							</vc-date-picker>
						</CCol>

						<CCol col="12">
							<template v-for="(content, type) in data">
								<h3 class="text-center">
									Résumé {{ typeTranslation[type] }} du
									{{ $moment(searchDate).format('DD/MM/YYYY') }}
								</h3>
								<div class="table-responsive" :key="type">
									<table class="table table-bordered col-sm-12 mt-3">
										<thead>
											<tr>
												<th scope="col">Bordereaux saisi</th>
												<th scope="col">Statut</th>
												<th scope="col">Quantité</th>
												<th scope="col">Poids</th>
												<th scope="col">Volume</th>
												<th scope="col">Actions</th>
											</tr>
										</thead>
										<tbody>
											<template v-for="(items, status) in content">
												<tr :key="status">
													<td class="col-1">
														<CIcon
															v-if="status !== 'undefined'"
															name="cil-check"
															style="color: green" />
														<CIcon v-else name="cil-ban" style="color: red" />
													</td>
													<td class="col-1">
														<CBadge :color="colorMapping[status]">{{
															stateMapping[status]
														}}</CBadge>
													</td>
													<td class="col-1">{{ totalQuantity(items) }}</td>
													<td class="col-1">
														{{ parseFloat(totalWeight(items)).toFixed(2) }} KG
													</td>
													<td class="col-1">
														{{ parseFloat(totalVolume(items)).toFixed(2) }}
													</td>
													<td>
														<CButton
															color="primary"
															@click="openDetails(type, status)">
															<CIcon name="cil-folder-open"></CIcon>
															<span class="btn-text">Voir les colis</span>
														</CButton>
													</td>
												</tr>
											</template>

											<tr>
												<td class="font-weight-bold">TOTAL</td>
												<td></td>
												<td>{{ totalQuantity(content, 1) }}</td>
												<td>
													{{ parseFloat(totalWeight(content, 1)).toFixed(2) }} KG
												</td>
												<td>{{ parseFloat(totalVolume(content, 1)).toFixed(2) }}</td>
												<td></td>
											</tr>
										</tbody>
									</table>
								</div>
								<hr class="my-5" />
							</template>
						</CCol>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
		<PackagesDetailsModal ref="detailsModal" />
	</div>
</template>
<script>
	import PackagesDetailsModal from './packages-details-modal';
	import { groupBy, sortBy, toPairs, fromPairs } from 'lodash';
	import mercure from '../../components/ghostlexly-components/libs/mercure';
	import Vue from 'vue';

	export default {
		name: 'summary-by-reception-type',
		components: { PackagesDetailsModal },

		data() {
			return {
				masks: {
					input: 'DD/MM/YYYY',
				},
				modelConfig: {
					type: 'string',
					mask: 'YYYY-MM-DD',
				},
				searchDate: this.$moment().format('YYYY-MM-DD'),
				data: {},
				stateTotals: [],
				stateMapping: {
					'order_item.pending': 'Étiquette non imprimée',
					'order_item.label_printed': 'Étiquette imprimée',
					'order_item.orphan': 'Colis retirés',
					'order_item.scanned': 'Colis scanné',
					'order_item.paused': 'Colis en pause',
					'order_item.refunded': 'Colis remboursé',
					undefined: 'Aucun',
				},
				colorMapping: {
					'order_item.pending': 'danger',
					'order_item.label_printed': 'warning',
					'order_item.orphan': 'warning',
					'order_item.scanned': 'success',
					'order_item.paused': 'danger',
					'order_item.refunded': 'warning',
				},
				typeTranslation: {
					'slip.reception_fax': 'Fax',
					'slip.reception_mail': 'Mail',
					'slip.reception_depot': 'Depôt',
					'slip.reception_colipays': 'Colipays',
					'slip.reception_app': 'Application',
				},
				dateFilterNameMapping: {
					'slip.reception_fax': 'faxReceivedDate',
					'slip.reception_mail': 'mailReceivedDate',
					'slip.reception_depot': 'depotReceivedDate',
					'slip.reception_colipays': 'colipaysReceivedDate',
					'slip.reception_app': 'appReceivedDate',
				},
			};
		},

		mounted() {
			this.getSummaries();
		},

		watch: {
			searchDate: function (newVal) {
				this.getSummaries();
			},
		},

		methods: {
			async getSummaries() {
				this.getSummary('slip.reception_fax', this.dateFilterNameMapping['slip.reception_fax']);
				this.getSummary('slip.reception_mail', this.dateFilterNameMapping['slip.reception_mail']);
				this.getSummary('slip.reception_depot', this.dateFilterNameMapping['slip.reception_depot']);
				this.getSummary(
					'slip.reception_colipays',
					this.dateFilterNameMapping['slip.reception_colipays']
				);
				this.getSummary('slip.reception_app', this.dateFilterNameMapping['slip.reception_app']);
			},

			getSummary(receptionMethod, dateFilterName) {
				this.$axios
					.get(
						`/api/slips/stats?${dateFilterName}=${this.searchDate}&receptionMethod=${receptionMethod}&itemsPerPage=999999`
					)
					.then(res => {
						// groupBy order item state's
						let output = {};
						output = groupBy(res.data['hydra:member'], item => {
							return item.completedOrderItem.state;
						});

						Vue.set(this.data, receptionMethod, output);

						// sortBy keys
						this.data = toPairs(this.data);
						this.data = sortBy(this.data, 0);
						this.data = fromPairs(this.data);
					})
					.catch(err => {
						console.log(err);
						this.$toast.error('Une erreur est survenue.');
					});
			},

			totalQuantity(data, depth = 0) {
				let total = 0;

				if (depth === 0) {
					for (let item of data) {
						if (item.completedOrderItem) {
							total += item.completedOrderItem.quantity;
						} else if (item.receptionProduct) {
							total += 1;
						}
					}
				} else {
					for (let depth of Object.values(data)) {
						for (let item of depth) {
							if (item.completedOrderItem) {
								total += item.completedOrderItem.quantity;
							} else if (item.receptionProduct) {
								total += 1;
							}
						}
					}
				}

				return total;
			},

			totalWeight(data, depth = 0) {
				let total = 0;

				if (depth === 0) {
					for (let item of data) {
						if (item.completedOrderItem) {
							total += item.completedOrderItem.weightNet;
						} else if (item.receptionProduct) {
							total += item.receptionProduct.weightNet;
						}
					}
				} else {
					for (let depth of Object.values(data)) {
						for (let item of depth) {
							if (item.completedOrderItem) {
								total += item.completedOrderItem.weightNet;
							} else if (item.receptionProduct) {
								total += item.receptionProduct.weightNet;
							}
						}
					}
				}

				return total;
			},

			totalVolume(data, depth = 0) {
				let total = 0;

				if (depth === 0) {
					for (let item of data) {
						if (item.completedOrderItem) {
							total += item.completedOrderItem.uv;
						} else if (item.receptionProduct) {
							total += item.receptionProduct.uv;
						}
					}
				} else {
					for (let depth of Object.values(data)) {
						for (let item of depth) {
							if (item.completedOrderItem) {
								total += item.completedOrderItem.uv;
							} else if (item.receptionProduct) {
								total += item.receptionProduct.uv;
							}
						}
					}
				}

				return total;
			},

			openDetails(type, status) {
				let baseQuery = '/api/slips/stats?';
				let params = new URLSearchParams();

				params.set(this.dateFilterNameMapping[type], this.searchDate);
				params.set('receptionMethod', type);

				if (status === 'undefined') {
					params.set('exists[orderItems]', 'false');
				} else {
					params.set('orderItems.state', status);
				}

				this.$refs.detailsModal.queryUrl = baseQuery + params.toString();
				this.$refs.detailsModal.showModal = true;
			},
		},
	};
</script>

<style>
	.table td {
		vertical-align: middle;
	}
	.row-total {
		background-color: #f2f2f3;
	}
	.btn-text {
		margin-left: 10px;
		vertical-align: middle;
	}
</style>
